import { render, staticRenderFns } from "./TdsReport.vue?vue&type=template&id=0f640402&"
import script from "./TdsReport.vue?vue&type=script&lang=js&"
export * from "./TdsReport.vue?vue&type=script&lang=js&"
import style0 from "./TdsReport.vue?vue&type=style&index=0&id=0f640402&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports